
import { defineComponent, ref } from "@vue/runtime-core";

import { usePosts } from "@/composables/usePosts";
import ThePosts from "@/components/ThePosts.vue";
import TheLoader from "@/components/TheLoader.vue";
import PageHeader from "@/components/PageHeader.vue";
import NoPostsFeedback from "@/components/NoPostsFeedback.vue";

export default defineComponent({
  components: { ThePosts, TheLoader, PageHeader, NoPostsFeedback },
  setup() {
    const basePath = ref(process.env.VUE_APP_BASE_URL);
    const { pagePhoto, isLoading, noPosts } = usePosts();

    return { basePath, pagePhoto, isLoading, noPosts };
  },
});
